/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("uk", {
  Redo: "\u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u0438",
  Undo: "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
  Cut: "\u0412\u0438\u0440\u0456\u0437\u0430\u0442\u0438",
  Copy: "\u041a\u043e\u043f\u0456\u044e\u0432\u0430\u0442\u0438",
  Paste: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438",
  "Select all":
    "\u0412\u0438\u0434\u0456\u043b\u0438\u0442\u0438 \u0432\u0441\u0435",
  "New document":
    "\u0421\u0442\u0432\u043e\u0440\u0438\u0442\u0438 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442",
  Ok: "\u0413\u0430\u0440\u0430\u0437\u0434",
  Cancel: "\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
  "Visual aids":
    "\u041d\u0430\u043e\u0447\u043d\u0456 \u043f\u0440\u0438\u043b\u0430\u0434\u0434\u044f",
  Bold: "\u0416\u0438\u0440\u043d\u0438\u0439",
  Italic: "\u041a\u0443\u0440\u0441\u0438\u0432",
  Underline:
    "\u041f\u0456\u0434\u043a\u0440\u0435\u0441\u043b\u0435\u043d\u043d\u044f",
  Strikethrough:
    "\u041f\u0435\u0440\u0435\u043a\u0440\u0435\u0441\u043b\u0435\u043d\u043d\u044f",
  Superscript:
    "\u041d\u0430\u0434\u0440\u044f\u0434\u043a\u043e\u0432\u0438\u0439 \u0441\u0438\u043c\u0432\u043e\u043b",
  Subscript:
    "\u041f\u0456\u0434\u0440\u044f\u0434\u043a\u043e\u0432\u0438\u0439 \u0441\u0438\u043c\u0432\u043e\u043b",
  "Clear formatting":
    "\u041e\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0444\u043e\u0440\u043c\u0430\u0442\u0443\u0432\u0430\u043d\u043d\u044f",
  "Align left":
    "\u041f\u043e \u043b\u0456\u0432\u043e\u043c\u0443 \u043a\u0440\u0430\u044e",
  "Align center":
    "\u0412\u0438\u0440\u0456\u0432\u043d\u044f\u0442\u0438 \u043f\u043e \u0446\u0435\u043d\u0442\u0440\u0443",
  "Align right":
    "\u0412\u0438\u0440\u0456\u0432\u043d\u044f\u0442\u0438 \u0437\u0430 \u043f\u0440\u0430\u0432\u0438\u043c \u043a\u0440\u0430\u0454\u043c",
  Justify:
    "\u0412\u0438\u0440\u0456\u0432\u043d\u044e\u0432\u0430\u043d\u043d\u044f",
  "Bullet list":
    "\u041d\u0435\u043d\u0443\u043c\u0435\u0440\u043e\u0432\u0430\u043d\u0438\u0439 \u0441\u043f\u0438\u0441\u043e\u043a",
  "Numbered list":
    "\u041d\u0443\u043c\u0435\u0440\u043e\u0432\u0430\u043d\u0438\u0439 \u0441\u043f\u0438\u0441\u043e\u043a",
  "Decrease indent":
    "\u0417\u043c\u0435\u043d\u0448\u0438\u0442\u0438 \u0432\u0456\u0434\u0441\u0442\u0443\u043f",
  "Increase indent":
    "\u0417\u0431\u0456\u043b\u044c\u0448\u0438\u0442\u0438 \u0432\u0456\u0434\u0441\u0442\u0443\u043f",
  Close: "\u0417\u0430\u043a\u0440\u0438\u0442\u0438",
  Formats: "\u0424\u043e\u0440\u043c\u0430\u0442\u0438",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043d\u0435 \u043f\u0456\u0434\u0442\u0440\u0438\u043c\u0443\u0454 \u043f\u0440\u044f\u043c\u0438\u0439 \u0434\u043e\u0441\u0442\u0443\u043f \u0434\u043e \u0431\u0443\u0444\u0435\u0440\u0430 \u043e\u0431\u043c\u0456\u043d\u0443. \u0412\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0439\u0442\u0435 \u043d\u0430\u0442\u043e\u043c\u0456\u0441\u0442\u044c \u0441\u043f\u043e\u043b\u0443\u0447\u0435\u043d\u043d\u044f \u043a\u043b\u0430\u0432\u0456\u0448 Ctrl\u00a0+\u00a0C/V/X.",
  Headers: "\u041a\u043e\u043b\u043e\u043d\u0442\u0438\u0442\u0443\u043b\u0438",
  "Header 1": "\u041a\u043e\u043b\u043e\u043d\u0442\u0438\u0442\u0443\u043b 1",
  "Header 2": "\u041a\u043e\u043b\u043e\u043d\u0442\u0438\u0442\u0443\u043b 2",
  "Header 3": "\u041a\u043e\u043b\u043e\u043d\u0442\u0438\u0442\u0443\u043b 3",
  "Header 4": "\u041a\u043e\u043b\u043e\u043d\u0442\u0438\u0442\u0443\u043b 4",
  "Header 5": "\u041a\u043e\u043b\u043e\u043d\u0442\u0438\u0442\u0443\u043b 5",
  "Header 6": "\u041a\u043e\u043b\u043e\u043d\u0442\u0438\u0442\u0443\u043b 6",
  Headings: "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043a\u0438",
  "Heading 1": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 1",
  "Heading 2": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 2",
  "Heading 3": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 3",
  "Heading 4": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 4",
  "Heading 5": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 5",
  "Heading 6": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a 6",
  Preformatted:
    "\u0424\u043e\u0440\u043c\u0430\u0442\u043e\u0432\u0430\u043d\u0438\u0439",
  Div: "\u0420\u043e\u0437\u0434\u0456\u043b",
  Pre:
    "\u041f\u043e\u043f\u0435\u0440\u0435\u0434\u043d\u0454 \u0444\u043e\u0440\u043c\u0430\u0442\u0443\u0432\u0430\u043d\u043d\u044f",
  Code: "\u041a\u043e\u0434",
  Paragraph: "\u0410\u0431\u0437\u0430\u0446",
  Blockquote:
    "\u0411\u043b\u043e\u043a \u0446\u0438\u0442\u0443\u0432\u0430\u043d\u043d\u044f",
  Inline: "\u0420\u044f\u0434\u043a\u043e\u0432\u0438\u0439",
  Blocks: "\u0411\u043b\u043e\u043a\u0438",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "\u0412\u0441\u0442\u0430\u0432\u043a\u0430 \u0437\u0434\u0456\u0439\u0441\u043d\u044e\u0454\u0442\u044c\u0441\u044f \u0443 \u0432\u0438\u0433\u043b\u044f\u0434\u0456 \u043f\u0440\u043e\u0441\u0442\u043e\u0433\u043e \u0442\u0435\u043a\u0441\u0442\u0443, \u043f\u043e\u043a\u0438 \u043d\u0435 \u0432\u0456\u0434\u043a\u043b\u044e\u0447\u0438\u0442\u0438 \u0434\u0430\u043d\u0443 \u043e\u043f\u0446\u0456\u044e.",
  Fonts: "\u0428\u0440\u0438\u0444\u0442\u0438",
  "Font Sizes":
    "\u0420\u043e\u0437\u043c\u0456\u0440\u0438 \u0448\u0440\u0438\u0444\u0442\u0443",
  Class: "\u041a\u043b\u0430\u0441",
  "Browse for an image":
    "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f",
  OR: "\u0410\u0411\u041e",
  "Drop an image here":
    "\u041f\u0435\u0440\u0435\u043c\u0456\u0441\u0442\u0456\u0442\u044c \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u0441\u044e\u0434\u0438",
  Upload: "\u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438",
  Block: "\u0411\u043b\u043e\u043a",
  Align:
    "\u0412\u0438\u0440\u0456\u0432\u043d\u044e\u0432\u0430\u043d\u043d\u044f",
  Default: "\u0421\u0442\u0430\u043d\u0434\u0430\u0440\u0442\u043d\u0438\u0439",
  Circle: "\u041e\u043a\u0440\u0443\u0436\u043d\u043e\u0441\u0442\u0456",
  Disc: "\u041a\u0440\u0443\u0433\u0438",
  Square: "\u041a\u0432\u0430\u0434\u0440\u0430\u0442\u0438",
  "Lower Alpha":
    "\u041c\u0430\u043b\u0456 \u043b\u0430\u0442\u0438\u043d\u0441\u044c\u043a\u0456 \u0431\u0443\u043a\u0432\u0438",
  "Lower Greek":
    "\u041c\u0430\u043b\u0456 \u0433\u0440\u0435\u0446\u044c\u043a\u0456 \u0431\u0443\u043a\u0432\u0438",
  "Lower Roman":
    "\u041c\u0430\u043b\u0456 \u0440\u0438\u043c\u0441\u044c\u043a\u0456 \u0446\u0438\u0444\u0440\u0438",
  "Upper Alpha":
    "\u0412\u0435\u043b\u0438\u043a\u0456 \u043b\u0430\u0442\u0438\u043d\u0441\u044c\u043a\u0456 \u0431\u0443\u043a\u0432\u0438",
  "Upper Roman":
    "\u0420\u0438\u043c\u0441\u044c\u043a\u0456 \u0446\u0438\u0444\u0440\u0438",
  "Anchor...": "\u042f\u043a\u0456\u0440\u2026",
  Name: "\u041d\u0430\u0437\u0432\u0430",
  Id: "\u041a\u043e\u0434",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "\u041a\u043e\u0434 \u043c\u0430\u0454 \u043f\u043e\u0447\u0438\u043d\u0430\u0442\u0438\u0441\u044f \u0437 \u043b\u0456\u0442\u0435\u0440\u0438 \u0456 \u043c\u043e\u0436\u0435 \u043c\u0456\u0441\u0442\u0438\u0442\u0438 \u043b\u0438\u0448\u0435 \u0441\u0438\u043c\u0432\u043e\u043b\u0438 \u043b\u0456\u0442\u0435\u0440, \u0446\u0438\u0444\u0440, \u0434\u0435\u0444\u0456\u0441\u0443, \u043a\u0440\u0430\u043f\u043a\u0438, \u043a\u043e\u043c\u0438 \u0430\u0431\u043e \u043d\u0438\u0436\u043d\u044c\u043e\u0433\u043e \u043f\u0456\u0434\u043a\u0440\u0435\u0441\u043b\u0435\u043d\u043d\u044f.",
  "You have unsaved changes are you sure you want to navigate away?":
    "\u0423 \u0412\u0430\u0441 \u0454 \u043d\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043d\u0456 \u0437\u043c\u0456\u043d\u0438. \u0412\u0438 \u0432\u043f\u0435\u0432\u043d\u0435\u043d\u0456, \u0449\u043e \u0445\u043e\u0447\u0435\u0442\u0435 \u043f\u0456\u0442\u0438?",
  "Restore last draft":
    "\u0412\u0456\u0434\u043d\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043e\u0441\u0442\u0430\u043d\u043d\u044c\u043e\u0433\u043e \u043f\u0440\u043e\u0435\u043a\u0442\u0443",
  "Special character...":
    "\u0421\u043f\u0435\u0446\u0456\u0430\u043b\u044c\u043d\u0438\u0439 \u0441\u0438\u043c\u0432\u043e\u043b\u2026",
  "Source code":
    "\u0412\u0438\u0445\u0456\u0434\u043d\u0438\u0439 \u043a\u043e\u0434",
  "Insert/Edit code sample":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438/\u0437\u043c\u0456\u043d\u0438\u0442\u0438 \u043f\u0440\u0438\u043a\u043b\u0430\u0434 \u043a\u043e\u0434\u0443",
  Language: "\u041c\u043e\u0432\u0430",
  "Code sample...":
    "\u041f\u0440\u0438\u043a\u043b\u0430\u0434 \u043a\u043e\u0434\u0443\u2026",
  "Color Picker":
    "\u041f\u0456\u043f\u0435\u0442\u043a\u0430 \u043a\u043e\u043b\u044c\u043e\u0440\u0443",
  R: "\u0427",
  G: "\u0417",
  B: "\u0411",
  "Left to right":
    "\u0417\u043b\u0456\u0432\u0430 \u043d\u0430\u043f\u0440\u0430\u0432\u043e",
  "Right to left":
    "\u0421\u043f\u0440\u0430\u0432\u0430 \u043d\u0430\u043b\u0456\u0432\u043e",
  "Emoticons...": "\u0421\u043c\u0430\u0439\u043b\u0438\u043a\u0438\u2026",
  "Metadata and Document Properties":
    "\u041c\u0435\u0442\u0430\u0434\u0430\u043d\u0456 \u0456 \u0432\u043b\u0430\u0441\u0442\u0438\u0432\u043e\u0441\u0442\u0456 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u0430",
  Title: "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a",
  Keywords:
    "\u041a\u043b\u044e\u0447\u043e\u0432\u0456 \u0441\u043b\u043e\u0432\u0430",
  Description: "\u041e\u043f\u0438\u0441",
  Robots: "\u0420\u043e\u0431\u043e\u0442\u0438",
  Author: "\u0410\u0432\u0442\u043e\u0440",
  Encoding: "\u041a\u043e\u0434\u0443\u0432\u0430\u043d\u043d\u044f",
  Fullscreen:
    "\u041f\u043e\u0432\u043d\u043e\u0435\u043a\u0440\u0430\u043d\u043d\u0438\u0439 \u0440\u0435\u0436\u0438\u043c",
  Action: "\u0414\u0456\u044f",
  Shortcut: "\u042f\u0440\u043b\u0438\u043a",
  Help: "\u0414\u043e\u043f\u043e\u043c\u043e\u0433\u0430",
  Address: "\u0410\u0434\u0440\u0435\u0441\u0430",
  "Focus to menubar":
    "\u0424\u043e\u043a\u0443\u0441 \u043d\u0430 \u043c\u0435\u043d\u044e",
  "Focus to toolbar":
    "\u0424\u043e\u043a\u0443\u0441 \u043d\u0430 \u0456\u043d\u0441\u0442\u0440\u0443\u043c\u0435\u043d\u0442\u0430\u0445",
  "Focus to element path":
    "\u0424\u043e\u043a\u0443\u0441 \u043d\u0430 \u0448\u043b\u044f\u0445\u0443",
  "Focus to contextual toolbar":
    "\u0424\u043e\u043a\u0443\u0441 \u043d\u0430 \u043a\u043e\u043d\u0442\u0435\u043a\u0441\u0442\u0456",
  "Insert link (if link plugin activated)":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f (\u044f\u043a\u0449\u043e \u043f\u043b\u0430\u0433\u0456\u043d \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u044c \u0430\u043a\u0442\u0438\u0432\u043e\u0432\u0430\u043d\u0438\u0439)",
  "Save (if save plugin activated)":
    "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 (\u044f\u043a\u0449\u043e \u043f\u043b\u0430\u0433\u0456\u043d \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043d\u043d\u044f \u0430\u043a\u0442\u0438\u0432\u043e\u0432\u0430\u043d\u043e)",
  "Find (if searchreplace plugin activated)":
    "\u0417\u043d\u0430\u0439\u0442\u0438 (\u044f\u043a\u0449\u043e \u043f\u043b\u0430\u0433\u0456\u043d \u043f\u043e\u0448\u0443\u043a\u0443 \u0430\u043a\u0442\u0438\u0432\u043e\u0432\u0430\u043d\u043e)",
  "Plugins installed ({0}):":
    "\u0412\u0441\u0442\u0430\u043d\u043e\u0432\u043b\u0435\u043d\u0456 \u043f\u043b\u0430\u0433\u0456\u043d\u0438 ({0}):",
  "Premium plugins:":
    "\u041f\u0440\u0435\u043c\u0456\u0443\u043c \u043f\u043b\u0430\u0433\u0456\u043d\u0438:",
  "Learn more...": "\u0414\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u043e...",
  "You are using {0}":
    "\u0423 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u0456 {0}",
  Plugins: "\u041f\u043b\u0430\u0433\u0456\u043d\u0438",
  "Handy Shortcuts":
    "\u041a\u043b\u0430\u0432\u0456\u0430\u0442\u0443\u0440\u043d\u0456 \u0441\u043a\u043e\u0440\u043e\u0447\u0435\u043d\u043d\u044f",
  "Horizontal line":
    "\u0413\u043e\u0440\u0438\u0437\u043e\u043d\u0442\u0430\u043b\u044c\u043d\u0430 \u043b\u0456\u043d\u0456\u044f",
  "Insert/edit image":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438/\u0437\u043c\u0456\u043d\u0438\u0442\u0438 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f",
  "Image description":
    "\u041e\u043f\u0438\u0441 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f",
  Source: "\u0414\u0436\u0435\u0440\u0435\u043b\u043e",
  Dimensions: "\u0420\u043e\u0437\u043c\u0456\u0440",
  "Constrain proportions":
    "\u0417\u0431\u0435\u0440\u0456\u0433\u0430\u0442\u0438 \u043f\u0440\u043e\u043f\u043e\u0440\u0446\u0456\u0457",
  General: "\u0417\u0430\u0433\u0430\u043b\u044c\u043d\u0456",
  Advanced: "\u0420\u043e\u0437\u0448\u0438\u0440\u0435\u043d\u0456",
  Style: "\u0421\u0442\u0438\u043b\u044c",
  "Vertical space":
    "\u0412\u0435\u0440\u0442\u0438\u043a\u0430\u043b\u044c\u043d\u0438\u0439 \u0456\u043d\u0442\u0435\u0440\u0432\u0430\u043b",
  "Horizontal space":
    "\u0413\u043e\u0440\u0438\u0437\u043e\u043d\u0442\u0430\u043b\u044c\u043d\u0438\u0439 \u0456\u043d\u0442\u0435\u0440\u0432\u0430\u043b",
  Border: "\u041c\u0435\u0436\u0430",
  "Insert image":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f",
  "Image...":
    "\u0417\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f\u2026",
  "Image list":
    "\u041f\u0435\u0440\u0435\u043b\u0456\u043a \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c",
  "Rotate counterclockwise":
    "\u041f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u0438 \u043f\u0440\u043e\u0442\u0438 \u0433\u043e\u0434\u0438\u043d\u043d\u0438\u043a\u043e\u0432\u043e\u0457 \u0441\u0442\u0440\u0456\u043b\u043a\u0438",
  "Rotate clockwise":
    "\u041f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u0438 \u0437\u0430 \u0433\u043e\u0434\u0438\u043d\u043d\u0438\u043a\u043e\u0432\u043e\u044e \u0441\u0442\u0440\u0456\u043b\u043a\u043e\u044e",
  "Flip vertically":
    "\u0412\u0456\u0434\u043e\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u043f\u043e \u0432\u0435\u0440\u0442\u0438\u043a\u0430\u043b\u0456",
  "Flip horizontally":
    "\u0412\u0456\u0434\u043e\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u043f\u043e \u0433\u043e\u0440\u0438\u0437\u043e\u043d\u0442\u0430\u043b\u0456",
  "Edit image":
    "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f",
  "Image options":
    "\u041d\u0430\u043b\u0430\u0448\u0442\u0443\u0432\u0430\u043d\u043d\u044f \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f",
  "Zoom in": "\u041d\u0430\u0431\u043b\u0438\u0437\u0438\u0442\u0438",
  "Zoom out": "\u0412\u0456\u0434\u0434\u0430\u043b\u0438\u0442\u0438",
  Crop: "\u041e\u0431\u0440\u0456\u0437\u0430\u0442\u0438",
  Resize:
    "\u0417\u043c\u0456\u043d\u0438\u0442\u0438 \u0440\u043e\u0437\u043c\u0456\u0440",
  Orientation: "\u041e\u0440\u0456\u0454\u043d\u0442\u0430\u0446\u0456\u044f",
  Brightness: "\u042f\u0441\u043a\u0440\u0430\u0432\u0456\u0441\u0442\u044c",
  Sharpen: "\u0427\u0456\u0442\u043a\u0456\u0441\u0442\u044c",
  Contrast: "\u041a\u043e\u043d\u0442\u0440\u0430\u0441\u0442",
  "Color levels":
    "\u0420\u0456\u0432\u043d\u0456 \u043a\u043e\u043b\u044c\u043e\u0440\u0456\u0432",
  Gamma: "\u0413\u0430\u043c\u043c\u0430",
  Invert: "\u0406\u043d\u0432\u0435\u0440\u0441\u0456\u044f",
  Apply: "\u0417\u0430\u0441\u0442\u043e\u0441\u0443\u0432\u0430\u0442\u0438",
  Back: "\u041f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u0438\u0441\u044f",
  "Insert date/time":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0434\u0430\u0442\u0443/\u0447\u0430\u0441",
  "Date/time": "\u0414\u0430\u0442\u0430/\u0447\u0430\u0441",
  "Insert/Edit Link":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438/\u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f",
  "Insert/edit link":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438/\u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f",
  "Text to display":
    "\u0422\u0435\u043a\u0441\u0442 \u0434\u043b\u044f \u0432\u0456\u0434\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f",
  Url:
    "\u0410\u0434\u0440\u0435\u0441\u0430 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f",
  "Open link in...":
    "\u0412\u0456\u0434\u043a\u0440\u0438\u0442\u0438 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u0432\u2026",
  "Current window":
    "\u0423 \u043f\u043e\u0442\u043e\u0447\u043d\u043e\u043c\u0443 \u0432\u0456\u043a\u043d\u0456",
  None: "\u041d\u0456",
  "New window":
    "\u0423 \u043d\u043e\u0432\u043e\u043c\u0443 \u0432\u0456\u043a\u043d\u0456",
  "Remove link":
    "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f",
  Anchors: "\u042f\u043a\u043e\u0440\u0456",
  "Link...": "\u041f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f\u2026",
  "Paste or type a link":
    "\u041d\u0430\u043f\u0438\u0441\u0430\u0442\u0438 \u0430\u0431\u043e \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "\u0421\u0445\u043e\u0436\u0435, \u0449\u043e \u0432\u0438 \u0432\u0432\u0435\u043b\u0438 \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u043e\u0457 \u043f\u043e\u0448\u0442\u0438. \u0412\u0438 \u0431\u0430\u0436\u0430\u0454\u0442\u0435 \u0434\u043e\u0434\u0430\u0442\u0438 mailto: \u043f\u0440\u0435\u0444\u0456\u043a\u0441?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "\u0421\u0445\u043e\u0436\u0435, \u0449\u043e \u0432\u0438 \u0432\u0432\u0435\u043b\u0438 \u0437\u043e\u0432\u043d\u0456\u0448\u043d\u0454 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f. \u0412\u0438 \u0431\u0430\u0436\u0430\u0454\u0442\u0435 \u0434\u043e\u0434\u0430\u0442\u0438 http:// \u043f\u0440\u0435\u0444\u0456\u043a\u0441?",
  "Link list":
    "\u041f\u0435\u0440\u0435\u043b\u0456\u043a \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u044c",
  "Insert video":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0432\u0456\u0434\u0435\u043e",
  "Insert/edit video":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438/\u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0432\u0456\u0434\u0435\u043e",
  "Insert/edit media":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438/\u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0430\u0443\u0434\u0456\u043e",
  "Alternative source":
    "\u0410\u043b\u044c\u0442\u0435\u0440\u043d\u0430\u0442\u0438\u0432\u043d\u0435 \u0434\u0436\u0435\u0440\u0435\u043b\u043e",
  "Alternative source URL":
    "\u041f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u043d\u0430 \u0430\u043b\u044c\u0442\u0435\u0440\u043d\u0430\u0442\u0438\u0432\u043d\u0435 \u0434\u0436\u0435\u0440\u0435\u043b\u043e",
  "Media poster (Image URL)":
    "\u0421\u0432\u0456\u0442\u043b\u0438\u043d\u0430 \u043c\u0435\u0434\u0456\u0430 (\u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u043d\u0430 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f)",
  "Paste your embed code below:":
    "\u0412\u0441\u0442\u0430\u0432\u0442\u0435 \u0432\u0430\u0448 \u043a\u043e\u0434 \u043d\u0438\u0436\u0447\u0435:",
  Embed:
    "\u041a\u043e\u0434 \u0434\u043b\u044f \u0432\u0441\u0442\u0430\u0432\u043a\u0438",
  "Media...": "\u041c\u0435\u0434\u0456\u0430\u2026",
  "Nonbreaking space":
    "\u041d\u0435\u0440\u043e\u0437\u0440\u0438\u0432\u043d\u0438\u0439 \u043f\u0440\u043e\u0431\u0456\u043b",
  "Page break":
    "\u0420\u043e\u0437\u0440\u0438\u0432 \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0438",
  "Paste as text":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u044f\u043a \u0442\u0435\u043a\u0441\u0442",
  Preview:
    "\u041f\u043e\u043f\u0435\u0440\u0435\u0434\u043d\u0456\u0439 \u043f\u0435\u0440\u0435\u0433\u043b\u044f\u0434",
  "Print...": "\u0414\u0440\u0443\u043a\u0443\u0432\u0430\u0442\u0438\u2026",
  Save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
  Find: "\u0417\u043d\u0430\u0439\u0442\u0438",
  "Replace with":
    "\u0417\u0430\u043c\u0456\u043d\u0438\u0442\u0438 \u043d\u0430",
  Replace: "\u0417\u0430\u043c\u0456\u043d\u0438\u0442\u0438",
  "Replace all":
    "\u0417\u0430\u043c\u0456\u043d\u0438\u0442\u0438 \u0432\u0441\u0435",
  Previous: "\u041f\u043e\u043f\u0435\u0440\u0435\u0434\u043d\u0456\u0439",
  Next: "\u0412\u043d\u0438\u0437",
  "Find and replace...":
    "\u041f\u043e\u0448\u0443\u043a \u0456 \u0437\u0430\u043c\u0456\u043d\u0430\u2026",
  "Could not find the specified string.":
    "\u0412\u043a\u0430\u0437\u0430\u043d\u0438\u0439 \u0440\u044f\u0434\u043e\u043a \u043d\u0435 \u0437\u043d\u0430\u0439\u0434\u0435\u043d\u043e",
  "Match case":
    "\u0412\u0440\u0430\u0445\u043e\u0432\u0443\u0432\u0430\u0442\u0438 \u0440\u0435\u0433\u0456\u0441\u0442\u0440",
  "Find whole words only":
    "\u0428\u0443\u043a\u0430\u0442\u0438 \u0442\u0456\u043b\u044c\u043a\u0438 \u0446\u0456\u043b\u0456 \u0441\u043b\u043e\u0432\u0430",
  "Spell check":
    "\u041f\u0435\u0440\u0435\u0432\u0456\u0440\u043a\u0430 \u043f\u0440\u0430\u0432\u043e\u043f\u0438\u0441\u0443",
  Ignore: "\u0406\u0433\u043d\u043e\u0440\u0443\u0432\u0430\u0442\u0438",
  "Ignore all":
    "\u0406\u0433\u043d\u043e\u0440\u0443\u0432\u0430\u0442\u0438 \u0432\u0441\u0435",
  Finish: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438",
  "Add to Dictionary":
    "\u0414\u043e\u0434\u0430\u0442\u0438 \u0434\u043e \u0421\u043b\u043e\u0432\u043d\u0438\u043a\u0430",
  "Insert table":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0442\u0430\u0431\u043b\u0438\u0446\u044e",
  "Table properties":
    "\u0412\u043b\u0430\u0441\u0442\u0438\u0432\u043e\u0441\u0442\u0456 \u0442\u0430\u0431\u043b\u0438\u0446\u0456",
  "Delete table":
    "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0442\u0430\u0431\u043b\u0438\u0446\u044e",
  Cell: "\u041a\u043e\u043c\u0456\u0440\u043a\u0430",
  Row: "\u0420\u044f\u0434\u043e\u043a",
  Column: "\u0421\u0442\u043e\u0432\u043f\u0435\u0446\u044c",
  "Cell properties":
    "\u041f\u0430\u0440\u0430\u043c\u0435\u0442\u0440\u0438 \u043a\u043e\u043c\u0456\u0440\u043a\u0438",
  "Merge cells":
    "\u041e\u0431'\u0454\u0434\u043d\u0430\u0442\u0438 \u043a\u043e\u043c\u0456\u0440\u043a\u0438",
  "Split cell":
    "\u0420\u043e\u0437\u0431\u0438\u0442\u0438 \u043a\u043e\u043c\u0456\u0440\u043a\u0443",
  "Insert row before":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043f\u043e\u0440\u043e\u0436\u043d\u0456\u0439 \u0440\u044f\u0434\u043e\u043a \u0437\u0432\u0435\u0440\u0445\u0443",
  "Insert row after":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043f\u043e\u0440\u043e\u0436\u043d\u0456\u0439 \u0440\u044f\u0434\u043e\u043a \u0437\u043d\u0438\u0437\u0443",
  "Delete row":
    "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0440\u044f\u0434\u043e\u043a",
  "Row properties":
    "\u041f\u0430\u0440\u0430\u043c\u0435\u0442\u0440\u0438 \u0440\u044f\u0434\u043a\u0430",
  "Cut row":
    "\u0412\u0438\u0440\u0456\u0437\u0430\u0442\u0438 \u0440\u044f\u0434\u043e\u043a",
  "Copy row":
    "\u041a\u043e\u043f\u0456\u044e\u0432\u0430\u0442\u0438 \u0440\u044f\u0434\u043e\u043a",
  "Paste row before":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0440\u044f\u0434\u043e\u043a \u0437\u0432\u0435\u0440\u0445\u0443",
  "Paste row after":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0440\u044f\u0434\u043e\u043a \u0437\u043d\u0438\u0437\u0443",
  "Insert column before":
    "\u0414\u043e\u0434\u0430\u0442\u0438 \u0441\u0442\u043e\u0432\u043f\u0435\u0446\u044c \u043b\u0456\u0432\u043e\u0440\u0443\u0447",
  "Insert column after":
    "\u0414\u043e\u0434\u0430\u0442\u0438 \u0441\u0442\u043e\u0432\u043f\u0435\u0446\u044c \u043f\u0440\u0430\u0432\u043e\u0440\u0443\u0447",
  "Delete column":
    "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0441\u0442\u043e\u0432\u043f\u0435\u0446\u044c",
  Cols: "\u0421\u0442\u043e\u0432\u043f\u0446\u0456",
  Rows: "\u0420\u044f\u0434\u043a\u0438",
  Width: "\u0428\u0438\u0440\u0438\u043d\u0430",
  Height: "\u0412\u0438\u0441\u043e\u0442\u0430",
  "Cell spacing":
    "\u0412\u0456\u0434\u0441\u0442\u0430\u043d\u044c \u043c\u0456\u0436 \u043a\u043e\u043c\u0456\u0440\u043a\u0430\u043c\u0438",
  "Cell padding":
    "\u041f\u043e\u043b\u044f \u043a\u043e\u043c\u0456\u0440\u043e\u043a",
  "Show caption":
    "\u041f\u043e\u043a\u0430\u0437\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a",
  Left:
    "\u041f\u043e \u043b\u0456\u0432\u043e\u043c\u0443 \u043a\u0440\u0430\u044e",
  Center: "\u041f\u043e \u0446\u0435\u043d\u0442\u0440\u0443",
  Right:
    "\u041f\u043e \u043f\u0440\u0430\u0432\u043e\u043c\u0443 \u043a\u0440\u0430\u044e",
  "Cell type": "\u0422\u0438\u043f \u043a\u043e\u043c\u0456\u0440\u043a\u0438",
  Scope: "\u0421\u0444\u0435\u0440\u0430",
  Alignment:
    "\u0412\u0438\u0440\u0456\u0432\u043d\u044e\u0432\u0430\u043d\u043d\u044f",
  "H Align":
    "\u0413\u043e\u0440\u0438\u0437\u043e\u043d\u0442\u0430\u043b\u044c\u043d\u0435  \u0432\u0438\u0440\u0456\u0432\u043d\u044e\u0432\u0430\u043d\u043d\u044f",
  "V Align":
    "\u0412\u0435\u0440\u0442\u0438\u043a\u0430\u043b\u044c\u043d\u0435 \u0432\u0438\u0440\u0456\u0432\u043d\u044e\u0432\u0430\u043d\u043d\u044f",
  Top:
    "\u041f\u043e \u0432\u0435\u0440\u0445\u043d\u044c\u043e\u043c\u0443 \u043a\u0440\u0430\u044e",
  Middle: "\u041f\u043e \u0446\u0435\u043d\u0442\u0440\u0443",
  Bottom:
    "\u041f\u043e \u043d\u0438\u0436\u043d\u044c\u043e\u043c\u0443 \u043a\u0440\u0430\u044e",
  "Header cell": "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a",
  "Row group":
    "\u0413\u0440\u0443\u043f\u0430 \u0440\u044f\u0434\u043a\u0456\u0432",
  "Column group":
    "\u0413\u0440\u0443\u043f\u0430 \u0441\u0442\u043e\u0432\u043f\u0446\u0456\u0432",
  "Row type": "\u0422\u0438\u043f \u0440\u044f\u0434\u043a\u0430",
  Header:
    "\u0412\u0435\u0440\u0445\u043d\u0456\u0439 \u043a\u043e\u043b\u043e\u043d\u0442\u0438\u0442\u0443\u043b",
  Body: "\u0422\u0456\u043b\u043e",
  Footer:
    "\u041d\u0438\u0436\u043d\u0456\u0439 \u043a\u043e\u043b\u043e\u043d\u0442\u0438\u0442\u0443\u043b",
  "Border color":
    "\u043a\u043e\u043b\u0456\u0440 \u0440\u0430\u043c\u043a\u0438",
  "Insert template...":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0448\u0430\u0431\u043b\u043e\u043d\u2026",
  Templates: "\u0428\u0430\u0431\u043b\u043e\u043d\u0438",
  Template: "\u0428\u0430\u0431\u043b\u043e\u043d",
  "Text color":
    "\u041a\u043e\u043b\u0456\u0440 \u0442\u0435\u043a\u0441\u0442\u0443",
  "Background color": "\u041a\u043e\u043b\u0456\u0440 \u0444\u043e\u043d\u0443",
  "Custom...":
    "\u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044c\u043a\u0438\u0439",
  "Custom color":
    "\u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044c\u043a\u0438\u0439 \u043a\u043e\u043b\u0456\u0440",
  "No color": "\u0431\u0435\u0437 \u043a\u043e\u043b\u044c\u043e\u0440\u0443",
  "Remove color":
    "\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u043a\u043e\u043b\u0456\u0440",
  "Table of Contents": "\u0417\u043c\u0456\u0441\u0442",
  "Show blocks":
    "\u041f\u043e\u043a\u0430\u0437\u0443\u0432\u0430\u0442\u0438 \u0431\u043b\u043e\u043a\u0438",
  "Show invisible characters":
    "\u041f\u043e\u043a\u0430\u0437\u0443\u0432\u0430\u0442\u0438 \u043d\u0435\u0432\u0438\u0434\u0438\u043c\u0456 \u0441\u0438\u043c\u0432\u043e\u043b\u0438",
  "Word count":
    "\u041a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c \u0441\u043b\u0456\u0432",
  Count: "\u041b\u0456\u0447\u0438\u043b\u044c\u043d\u0438\u043a",
  Document: "\u0414\u043e\u043a\u0443\u043c\u0435\u043d\u0442",
  Selection: "\u0412\u0438\u0434\u0456\u043b\u0435\u043d\u043d\u044f",
  Words: "\u0421\u043b\u043e\u0432\u0430",
  "Words: {0}":
    "\u041a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c \u0441\u043b\u0456\u0432: {0}",
  "{0} words": "{0} \u0441\u043b\u0456\u0432",
  File: "\u0424\u0430\u0439\u043b",
  Edit: "\u0417\u043c\u0456\u043d\u0438\u0442\u0438",
  Insert: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438",
  View: "\u0412\u0438\u0433\u043b\u044f\u0434",
  Format: "\u0424\u043e\u0440\u043c\u0430\u0442",
  Table: "\u0422\u0430\u0431\u043b\u0438\u0446\u044f",
  Tools: "\u0406\u043d\u0441\u0442\u0440\u0443\u043c\u0435\u043d\u0442\u0438",
  "Powered by {0}": "\u041f\u0440\u0430\u0446\u044e\u0454 \u043d\u0430 {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "\u0422\u0435\u043a\u0441\u0442\u043e\u0432\u0435 \u043f\u043e\u043b\u0435. \u041d\u0430\u0442\u0438\u0441\u043d\u0456\u0442\u044c ALT-F9 \u0449\u043e\u0431 \u0432\u0438\u043a\u043b\u0438\u043a\u0430\u0442\u0438 \u043c\u0435\u043d\u044e, ALT-F10 \u043f\u0430\u043d\u0435\u043b\u044c \u0456\u043d\u0441\u0442\u0440\u0443\u043c\u0435\u043d\u0442\u0456\u0432, ALT-0 \u0434\u043b\u044f \u0432\u0438\u043a\u043b\u0438\u043a\u0443 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u0438.",
  "Image title":
    "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f",
  "Border width":
    "\u0428\u0438\u0440\u0438\u043d\u0430 \u043c\u0435\u0436\u0456",
  "Border style": "\u0421\u0442\u0438\u043b\u044c \u043c\u0435\u0436\u0456",
  Error: "\u041f\u043e\u043c\u0438\u043b\u043a\u0430",
  Warn:
    "\u041f\u043e\u043f\u0435\u0440\u0435\u0434\u0436\u0435\u043d\u043d\u044f",
  Valid: "\u0412\u0456\u0440\u043d\u0438\u0439",
  "To open the popup, press Shift+Enter":
    "\u0429\u043e\u0431 \u0432\u0456\u0434\u043a\u0440\u0438\u0442\u0438 \u0441\u043f\u043b\u0438\u0432\u043d\u0435 \u0432\u0456\u043a\u043d\u043e, \u043d\u0430\u0442\u0438\u0441\u043d\u0456\u0442\u044c Shift\u00a0+\u00a0Enter",
  "Rich Text Area. Press ALT-0 for help.":
    "\u041e\u0431\u043b\u0430\u0441\u0442\u044c \u0444\u043e\u0440\u043c\u0430\u0442\u043e\u0432\u0430\u043d\u043e\u0433\u043e \u0442\u0435\u043a\u0441\u0442\u0443. \u041d\u0430\u0442\u0438\u0441\u043d\u0456\u0442\u044c ALT\u00a0+\u00a00, \u0449\u043e\u0431 \u0432\u0456\u0434\u043a\u0440\u0438\u0442\u0438 \u0434\u043e\u0432\u0456\u0434\u043a\u0443.",
  "System Font":
    "\u0421\u0438\u0441\u0442\u0435\u043c\u043d\u0438\u0439 \u0448\u0440\u0438\u0444\u0442",
  "Failed to upload image: {0}":
    "\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0432\u0456\u0434\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f: {0}",
  "Failed to load plugin: {0} from url {1}":
    "\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438 \u043f\u043b\u0430\u0491\u0456\u043d: {0} \u0437\u0430 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f\u043c {1}",
  "Failed to load plugin url: {0}":
    "\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u043d\u0430 \u043f\u043b\u0430\u0491\u0456\u043d: {0}",
  "Failed to initialize plugin: {0}":
    "\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0456\u043d\u0456\u0446\u0456\u0430\u043b\u0456\u0437\u0443\u0432\u0430\u0442\u0438 \u043f\u043b\u0430\u0491\u0456\u043d: {0}",
  example: "\u043f\u0440\u0438\u043a\u043b\u0430\u0434",
  Search: "\u041f\u043e\u0448\u0443\u043a",
  All: "\u0412\u0441\u0435",
  Currency: "\u0412\u0430\u043b\u044e\u0442\u0430",
  Text: "\u0422\u0435\u043a\u0441\u0442",
  Quotations: "\u0426\u0438\u0442\u0443\u0432\u0430\u043d\u043d\u044f",
  Mathematical:
    "\u041c\u0430\u0442\u0435\u043c\u0430\u0442\u0438\u0447\u043d\u0456 \u0441\u0438\u043c\u0432\u043e\u043b\u0438",
  "Extended Latin":
    "\u0420\u043e\u0437\u0448\u0438\u0440\u0435\u043d\u0430 \u043b\u0430\u0442\u0438\u043d\u0438\u0446\u044f",
  Symbols: "\u0421\u0438\u043c\u0432\u043e\u043b\u0438",
  Arrows: "\u0421\u0442\u0440\u0456\u043b\u043a\u0438",
  "User Defined":
    "\u0412\u0438\u0437\u043d\u0430\u0447\u0435\u043d\u0456 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0435\u043c",
  "dollar sign":
    "\u0437\u043d\u0430\u043a \u0434\u043e\u043b\u0430\u0440\u0430",
  "currency sign":
    "\u0437\u043d\u0430\u043a \u0432\u0430\u043b\u044e\u0442\u0438",
  "euro-currency sign": "\u0437\u043d\u0430\u043a \u0454\u0432\u0440\u043e",
  "colon sign":
    "\u0437\u043d\u0430\u043a \u0434\u0432\u043e\u043a\u0440\u0430\u043f\u043a\u0438",
  "cruzeiro sign":
    "\u0437\u043d\u0430\u043a \u043a\u0440\u0443\u0437\u0435\u0439\u0440\u043e",
  "french franc sign":
    "\u0437\u043d\u0430\u043a \u0444\u0440\u0430\u043d\u0446\u0443\u0437\u044c\u043a\u043e\u0433\u043e \u0444\u0440\u0430\u043d\u043a\u0443",
  "lira sign": "\u0437\u043d\u0430\u043a \u043b\u0456\u0440\u0438",
  "mill sign": "\u0437\u043d\u0430\u043a \u043c\u0456\u043b\u044e",
  "naira sign": "\u0437\u043d\u0430\u043a \u043d\u0430\u0439\u0440\u0438",
  "peseta sign":
    "\u0437\u043d\u0430\u043a \u043f\u0435\u0441\u0435\u0442\u0438",
  "rupee sign": "\u0437\u043d\u0430\u043a \u0440\u0443\u043f\u0456\u0457",
  "won sign": "\u0437\u043d\u0430\u043a \u0432\u043e\u043d\u0438",
  "new sheqel sign":
    "\u0437\u043d\u0430\u043a \u043d\u043e\u0432\u043e\u0433\u043e \u0448\u0435\u043a\u0435\u043b\u044f",
  "dong sign": "\u0437\u043d\u0430\u043a \u0434\u043e\u043d\u0433\u0443",
  "kip sign": "\u0437\u043d\u0430\u043a \u043a\u0456\u043f\u0443",
  "tugrik sign":
    "\u0437\u043d\u0430\u043a \u0442\u0443\u0433\u0440\u0438\u043a\u0430",
  "drachma sign":
    "\u0437\u043d\u0430\u043a \u0434\u0440\u0430\u0445\u043c\u0438",
  "german penny symbol":
    "\u0437\u043d\u0430\u043a \u043f\u0444\u0435\u043d\u0456\u0433\u0430",
  "peso sign": "\u0437\u043d\u0430\u043a \u043f\u0435\u0441\u043e",
  "guarani sign":
    "\u0437\u043d\u0430\u043a \u0433\u0443\u0430\u0440\u0430\u043d\u0456",
  "austral sign":
    "\u0437\u043d\u0430\u043a \u0430\u0443\u0441\u0442\u0440\u0430\u043b\u044e",
  "hryvnia sign":
    "\u0437\u043d\u0430\u043a \u0433\u0440\u0438\u0432\u043d\u0456",
  "cedi sign": "\u0437\u043d\u0430\u043a \u0441\u0435\u0434\u0456",
  "livre tournois sign":
    "\u0437\u043d\u0430\u043a \u0442\u0443\u0440\u0441\u044c\u043a\u043e\u0433\u043e \u043b\u0456\u0432\u0440\u0443",
  "spesmilo sign":
    "\u0437\u043d\u0430\u043a \u0441\u043f\u0435\u0441\u043c\u0456\u043b\u043e",
  "tenge sign": "\u0437\u043d\u0430\u043a \u0442\u0435\u043d\u0433\u0435",
  "indian rupee sign":
    "\u0437\u043d\u0430\u043a \u0456\u043d\u0434\u0456\u0439\u0441\u044c\u043a\u043e\u0457 \u0440\u0443\u043f\u0456\u0457",
  "turkish lira sign":
    "\u0437\u043d\u0430\u043a \u0442\u0443\u0440\u0435\u0446\u044c\u043a\u043e\u0457 \u043b\u0456\u0440\u0438",
  "nordic mark sign":
    "\u0437\u043d\u0430\u043a \u043f\u0456\u0432\u043d\u0456\u0447\u043d\u043e\u0457 \u043c\u0430\u0440\u043a\u0438",
  "manat sign": "\u0437\u043d\u0430\u043a \u043c\u0430\u043d\u0430\u0442\u0443",
  "ruble sign": "\u0437\u043d\u0430\u043a \u0440\u0443\u0431\u043b\u044f",
  "yen character": "\u0441\u0438\u043c\u0432\u043e\u043b \u0454\u043d\u0438",
  "yuan character":
    "\u0441\u0438\u043c\u0432\u043e\u043b \u044e\u0430\u043d\u044e",
  "yuan character, in hong kong and taiwan":
    "\u0441\u0438\u043c\u0432\u043e\u043b \u044e\u0430\u043d\u044e \u0432 \u0413\u043e\u043d\u043a\u043e\u043d\u0437\u0456 \u0456 \u0422\u0430\u0439\u0432\u0430\u043d\u0456",
  "yen/yuan character variant one":
    "\u0441\u0438\u043c\u0432\u043e\u043b \u0454\u043d\u0438/\u044e\u0430\u043d\u044e, \u043f\u0435\u0440\u0448\u0438\u0439 \u0432\u0430\u0440\u0456\u0430\u043d\u0442",
  "Loading emoticons...":
    "\u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0435\u043d\u043d\u044f \u0441\u043c\u0430\u0439\u043b\u0438\u043a\u0456\u0432\u2026",
  "Could not load emoticons":
    "\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u043c\u0430\u0439\u043b\u0438\u043a\u0438",
  People: "\u041b\u044e\u0434\u0438",
  "Animals and Nature":
    "\u0422\u0432\u0430\u0440\u0438\u043d\u0438 \u0442\u0430 \u043f\u0440\u0438\u0440\u043e\u0434\u0430",
  "Food and Drink":
    "\u0407\u0436\u0430 \u0442\u0430 \u043d\u0430\u043f\u043e\u0457",
  Activity: "\u0410\u043a\u0442\u0438\u0432\u043d\u0456\u0441\u0442\u044c",
  "Travel and Places":
    "\u041f\u043e\u0434\u043e\u0440\u043e\u0436\u0456 \u0456 \u043c\u0456\u0441\u0446\u044f",
  Objects: "\u041e\u0431\u2019\u0454\u043a\u0442\u0438",
  Flags: "\u041f\u0440\u0430\u043f\u043e\u0440\u0438",
  Characters: "\u0421\u0438\u043c\u0432\u043e\u043b\u0438",
  "Characters (no spaces)":
    "\u0421\u0438\u043c\u0432\u043e\u043b\u0438 (\u0431\u0435\u0437 \u043f\u0440\u043e\u0431\u0456\u043b\u0456\u0432)",
  "{0} characters":
    "\u041a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432: {0}",
  "Error: Form submit field collision.":
    "\u041f\u043e\u043c\u0438\u043b\u043a\u0430: \u043a\u043e\u043b\u0456\u0437\u0456\u044f \u043f\u043e\u043b\u044f \u0432\u0456\u0434\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u043d\u044f \u0444\u043e\u0440\u043c\u0438.",
  "Error: No form element found.":
    "\u041f\u043e\u043c\u0438\u043b\u043a\u0430: \u043d\u0435 \u0437\u043d\u0430\u0439\u0434\u0435\u043d\u043e \u0435\u043b\u0435\u043c\u0435\u043d\u0442\u0430 \u0444\u043e\u0440\u043c\u0438.",
  Update: "\u041e\u043d\u043e\u0432\u0438\u0442\u0438",
  "Color swatch":
    "\u0417\u0440\u0430\u0437\u043e\u043a \u043a\u043e\u043b\u044c\u043e\u0440\u0443",
  Turquoise: "\u0411\u0456\u0440\u044e\u0437\u043e\u0432\u0438\u0439",
  Green: "\u0417\u0435\u043b\u0435\u043d\u0438\u0439",
  Blue: "\u0421\u0438\u043d\u0456\u0439",
  Purple: "\u0424\u0456\u043e\u043b\u0435\u0442\u043e\u0432\u0438\u0439",
  "Navy Blue": "\u0422\u0435\u043c\u043d\u043e-\u0441\u0438\u043d\u0456\u0439",
  "Dark Turquoise":
    "\u0422\u0435\u043c\u043d\u043e-\u0431\u0456\u0440\u044e\u0437\u043e\u0432\u0438\u0439",
  "Dark Green":
    "\u0422\u0435\u043c\u043d\u043e-\u0437\u0435\u043b\u0435\u043d\u0438\u0439",
  "Medium Blue":
    "\u0421\u0435\u0440\u0435\u0434\u043d\u044c\u043e-\u0441\u0438\u043d\u0456\u0439",
  "Medium Purple":
    "\u0421\u0435\u0440\u0435\u0434\u043d\u044c\u043e-\u0444\u0456\u043e\u043b\u0435\u0442\u043e\u0432\u0438\u0439",
  "Midnight Blue":
    "\u041e\u043f\u0456\u0432\u043d\u0456\u0447\u043d\u0430 \u0431\u043b\u0430\u043a\u0438\u0442\u044c",
  Yellow: "\u0416\u043e\u0432\u0442\u0438\u0439",
  Orange:
    "\u041f\u043e\u043c\u0430\u0440\u0430\u043d\u0447\u0435\u0432\u0438\u0439",
  Red: "\u0427\u0435\u0440\u0432\u043e\u043d\u0438\u0439",
  "Light Gray":
    "\u0421\u0432\u0456\u0442\u043b\u043e-\u0441\u0456\u0440\u0438\u0439",
  Gray: "\u0421\u0456\u0440\u0438\u0439",
  "Dark Yellow":
    "\u0422\u0435\u043c\u043d\u043e-\u0436\u043e\u0432\u0442\u0438\u0439",
  "Dark Orange":
    "\u0422\u0435\u043c\u043d\u043e-\u043f\u043e\u043c\u0430\u0440\u0430\u043d\u0447\u0435\u0432\u0438\u0439",
  "Dark Red":
    "\u0422\u0435\u043c\u043d\u043e-\u0447\u0435\u0440\u0432\u043e\u043d\u0438\u0439",
  "Medium Gray":
    "\u0421\u0435\u0440\u0435\u0434\u043d\u044c\u043e-\u0441\u0456\u0440\u0438\u0439",
  "Dark Gray": "\u0422\u0435\u043c\u043d\u043e-\u0441\u0456\u0440\u0438\u0439",
  "Light Green":
    "\u0421\u0432\u0456\u0442\u043b\u043e-\u0437\u0435\u043b\u0435\u043d\u0438\u0439",
  "Light Yellow":
    "\u0421\u0432\u0456\u0442\u043b\u043e-\u0436\u043e\u0432\u0442\u0438\u0439",
  "Light Red":
    "\u0421\u0432\u0456\u0442\u043b\u043e-\u0447\u0435\u0440\u0432\u043e\u043d\u0438\u0439",
  "Light Purple":
    "\u0421\u0432\u0456\u0442\u043b\u043e-\u0444\u0456\u043e\u043b\u0435\u0442\u043e\u0432\u0438\u0439",
  "Light Blue":
    "\u0421\u0432\u0456\u0442\u043b\u043e-\u0441\u0438\u043d\u0456\u0439",
  "Dark Purple":
    "\u0422\u0435\u043c\u043d\u043e-\u0444\u0456\u043e\u043b\u0435\u0442\u043e\u0432\u0438\u0439",
  "Dark Blue":
    "\u0422\u0435\u043c\u043d\u043e-\u0433\u043e\u043b\u0443\u0431\u0438\u0439",
  Black: "\u0427\u043e\u0440\u043d\u0438\u0439",
  White: "\u0411\u0456\u043b\u0438\u0439",
  "Switch to or from fullscreen mode":
    "\u041f\u0435\u0440\u0435\u043c\u0438\u043a\u0430\u043d\u043d\u044f \u043f\u043e\u0432\u043d\u043e\u0435\u043a\u0440\u0430\u043d\u043d\u043e\u0433\u043e \u0440\u0435\u0436\u0438\u043c\u0443",
  "Open help dialog":
    "\u0412\u0456\u0434\u043a\u0440\u0438\u0442\u0438 \u0432\u0456\u043a\u043d\u043e \u0434\u043e\u0432\u0456\u0434\u043a\u0438",
  history: "\u0456\u0441\u0442\u043e\u0440\u0456\u044f",
  styles: "\u0441\u0442\u0438\u043b\u0456",
  formatting:
    "\u0444\u043e\u0440\u043c\u0430\u0442\u0443\u0432\u0430\u043d\u043d\u044f",
  alignment:
    "\u0432\u0438\u0440\u0456\u0432\u043d\u044e\u0432\u0430\u043d\u043d\u044f",
  indentation: "\u0432\u0456\u0434\u0441\u0442\u0443\u043f",
  "permanent pen": "\u043c\u0430\u0440\u043a\u0435\u0440",
  comments: "\u043a\u043e\u043c\u0435\u043d\u0442\u0430\u0440\u0456",
  "Format Painter":
    "\u0424\u043e\u0440\u043c\u0430\u0442 \u0437\u0430 \u0437\u0440\u0430\u0437\u043a\u043e\u043c",
  "Insert/edit iframe":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438/\u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 iframe",
  Capitalization:
    "\u0412\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u044f \u0432\u0435\u043b\u0438\u043a\u0438\u0445 \u043b\u0456\u0442\u0435\u0440",
  lowercase:
    "\u043d\u0438\u0436\u043d\u0456\u0439 \u0440\u0435\u0433\u0456\u0441\u0442\u0440",
  UPPERCASE:
    "\u0412\u0415\u0420\u0425\u041d\u0406\u0419 \u0420\u0415\u0413\u0406\u0421\u0422\u0420",
  "Title Case":
    "\u0420\u0435\u0433\u0456\u0441\u0442\u0440 \u0437\u0430\u0433\u043e\u043b\u043e\u0432\u043a\u0430",
  "Permanent Pen Properties":
    "\u0412\u043b\u0430\u0441\u0442\u0438\u0432\u043e\u0441\u0442\u0456 \u043c\u0430\u0440\u043a\u0435\u0440\u0430",
  "Permanent pen properties...":
    "\u0412\u043b\u0430\u0441\u0442\u0438\u0432\u043e\u0441\u0442\u0456 \u043c\u0430\u0440\u043a\u0435\u0440\u0430\u2026",
  Font: "\u0428\u0440\u0438\u0444\u0442",
  Size: "\u0420\u043e\u0437\u043c\u0456\u0440",
  "More...": "\u0411\u0456\u043b\u044c\u0448\u0435\u2026",
  "Spellcheck Language":
    "\u041c\u043e\u0432\u0430 \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u043a\u0438 \u043e\u0440\u0444\u043e\u0433\u0440\u0430\u0444\u0456\u0457",
  "Select...": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438\u2026",
  Preferences: "\u041f\u0430\u0440\u0430\u043c\u0435\u0442\u0440\u0438",
  Yes: "\u0422\u0430\u043a",
  No: "\u041d\u0456",
  "Keyboard Navigation":
    "\u041a\u0435\u0440\u0443\u0432\u0430\u043d\u043d\u044f \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u043a\u043b\u0430\u0432\u0456\u0430\u0442\u0443\u0440\u0438",
  Version: "\u0412\u0435\u0440\u0441\u0456\u044f",
  Anchor: "\u042f\u043a\u0456\u0440",
  "Special character":
    "\u0421\u043f\u0435\u0446\u0456\u0430\u043b\u044c\u043d\u0456 \u0441\u0438\u043c\u0432\u043e\u043b\u0438",
  "Code sample":
    "\u041f\u0440\u0438\u043a\u043b\u0430\u0434 \u043a\u043e\u0434\u0443",
  Color: "\u043a\u043e\u043b\u0456\u0440",
  Emoticons: "\u0415\u043c\u043e\u0446\u0456\u0457",
  "Document properties":
    "\u0412\u043b\u0430\u0441\u0442\u0438\u0432\u043e\u0441\u0442\u0456 \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u0430",
  Image: "\u0417\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f",
  "Insert link":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f",
  Target:
    "\u0412\u0456\u0434\u043a\u0440\u0438\u0432\u0430\u0442\u0438 \u043f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f",
  Link: "\u041f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f",
  Poster: "\u0417\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f",
  Media: "\u041c\u0435\u0434\u0456\u0430\u0434\u0430\u043d\u0456",
  Print: "\u0414\u0440\u0443\u043a\u0443\u0432\u0430\u0442\u0438",
  Prev: "\u0412\u0433\u043e\u0440\u0443",
  "Find and replace":
    "\u041f\u043e\u0448\u0443\u043a \u0456 \u0437\u0430\u043c\u0456\u043d\u0430",
  "Whole words": "\u0426\u0456\u043b\u0456 \u0441\u043b\u043e\u0432\u0430",
  Spellcheck:
    "\u041f\u0435\u0440\u0435\u0432\u0456\u0440\u043a\u0430 \u043e\u0440\u0444\u043e\u0433\u0440\u0430\u0444\u0456\u0457",
  Caption: "\u0417\u0430\u0433\u043e\u043b\u043e\u0432\u043e\u043a",
  "Insert template":
    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0448\u0430\u0431\u043b\u043e\u043d",
});
